module.exports = __webpack_public_path__ + "img/award_img03.daa0555d.jpg";